import axios from 'axios';
import { FullArticle, Section } from './knowledge-base-common.type';

export const queryKnowledgeBase = async (
    serviceUrl: string,
    query: string,
    sectionId?: string | null
): Promise<FullArticle[]> => {
    const res = await axios.get<FullArticle[]>(serviceUrl, { params: { query, sectionId } });
    return res.data;
};

export const getSectionsApi = async (serviceUrl: string) => {
    const res = await axios.get<Section[]>(serviceUrl);
    return res.data;
};

export const getById = async <Entity>(serviceUrl: string, id: string) => {
    const res = await axios.get<Entity>(serviceUrl, {
        params: { id },
    });

    axios.get('/_/service/isnareactcms/kb-article-view', {
        params: { id },
    });

    return res.data;
};
